/** Indonesian studios pay in Rupiah via Midtrans; everyone else is offered PayPal first.
 *  Timezone, not language — plenty of Indonesian studios run their browser in English. */
const INDONESIAN_ZONES = [
  "Asia/Jakarta",
  "Asia/Pontianak",
  "Asia/Makassar",
  "Asia/Jayapura",
];

export function defaultPaymentMethod() {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return INDONESIAN_ZONES.includes(zone) ? "midtrans" : "paypal";
  } catch {
    return "midtrans";
  }
}
